import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { ARButton } from 'three/examples/jsm/webxr/ARButton';

const ARScene = () => {
  const mountRef = useRef(null);
  let renderer, scene, camera;

  useEffect(() => {
    const init = () => {
      // Scene setup
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000);

      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.xr.enabled = true; // Enable WebXR
      mountRef.current.appendChild(renderer.domElement);

      // Add AR button
      document.body.appendChild(ARButton.createButton(renderer, { requiredFeatures: ['hit-test'] }));

      // Lighting
      const light = new THREE.HemisphereLight(0xffffff, 0xbbbbff, 1);
      scene.add(light);

      // Load 3D model
      const loader = new GLTFLoader();
      loader.load('https://y.pc5r.com/getGLB', function (gltf) {
        const model = gltf.scene;
        model.scale.set(0.5, 0.5, 0.5); // Scale model to appropriate size
        scene.add(model);

        // Position the model in front of the camera
        const reticle = new THREE.Mesh(
          new THREE.RingGeometry(0.1, 0.11, 32).rotateX(- Math.PI / 2),
          new THREE.MeshBasicMaterial()
        );
        reticle.matrixAutoUpdate = false;
        reticle.visible = false;
        scene.add(reticle);

        // Handle AR session
        const onSessionStart = () => {
          reticle.visible = true;
        };

        const onSessionEnd = () => {
          reticle.visible = false;
        };

        renderer.xr.addEventListener('sessionstart', onSessionStart);
        renderer.xr.addEventListener('sessionend', onSessionEnd);

        const controller = renderer.xr.getController(0);
        scene.add(controller);

        controller.addEventListener('select', () => {
          if (reticle.visible) {
            model.position.setFromMatrixPosition(reticle.matrix);
            scene.add(model.clone());
          }
        });

        // Animation loop
        const animate = () => {
          renderer.setAnimationLoop(render);
        };

        const render = () => {
          renderer.render(scene, camera);
        };

        animate();
      });
    };

    init();

    // Handle window resize
    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (renderer) {
        renderer.dispose();
        if (mountRef.current) {
          mountRef.current.removeChild(renderer.domElement);
        }
       
        const arButton = document.querySelector('.ar-button');
        if (arButton) {
          arButton.remove();
        }
      }
    };
  }, []);

  return <div ref={mountRef} style={{ width: '100vw', height: '100vh' }}></div>;
};

export default ARScene;
